/**
 * Cost View Action Types
 *
 * @author slak4170
 */

export const REQUEST_COST_VIEW_DATA = 'REQUEST_COST_VIEW_DATA';
export const RECEIVE_COST_VIEW_DATA = 'RECEIVE_COST_VIEW_DATA';

export const REQUEST_COST_VIEW_DETAILED_DATA = 'REQUEST_COST_VIEW_DETAILED_DATA';
export const RECEIVE_COST_VIEW_DETAILED_DATA = 'RECEIVE_COST_VIEW_DETAILED_DATA';

export const UPDATE_COST_VIEW_SEARCH_FILTER = 'UPDATE_COST_VIEW_SEARCH_FILTER';
export const RESET_COST_VIEW_SEARCH_FILTER = 'RESET_COST_VIEW_SEARCH_FILTER';

export const UPDATE_COST_VIEW_PRESERVE_STATE = 'UPDATE_COST_VIEW_PRESERVE_STATE';

export const UPDATE_COST_VIEW_CURRENT_DETAIL_SEARCH = 'UPDATE_COST_VIEW_CURRENT_DETAIL_SEARCH';

export const RESET_COST_VIEW_DATA = 'RESET_COST_VIEW_DATA';

export const REQUEST_WAREHOUSES_AND_OPCOS = 'REQUEST_WAREHOUSES_AND_OPCOS';

export const RECEIVE_MARGIN_INSIGHTS_HISTORY = 'RECEIVE_MARGIN_INSIGHTS_HISTORY';

export const requestCostViewData = (data) => ({ type: REQUEST_COST_VIEW_DATA, data });
export const receiveCostViewData = (data) => ({ type: RECEIVE_COST_VIEW_DATA, data });

export const requestCostViewDetailedData = (data) => ({ type: REQUEST_COST_VIEW_DETAILED_DATA, data });
export const receiveCostViewDetailedData = (data) => ({ type: RECEIVE_COST_VIEW_DETAILED_DATA, data });
export const receiveMarginInsightsHistory = (data) => ({ type: RECEIVE_MARGIN_INSIGHTS_HISTORY, data });

export const updateCostViewSearchFilter = (data) => ({ type: UPDATE_COST_VIEW_SEARCH_FILTER, data });
export const resetCostViewSearchFilter = (data) => ({ type: RESET_COST_VIEW_SEARCH_FILTER, data });

export const updateCostViewPreserveState = (data) => ({ type: UPDATE_COST_VIEW_PRESERVE_STATE, data });

export const resetCostViewData = () => ({ type: RESET_COST_VIEW_DATA });

export const requestWarehousesAndOpcos = () => ({ type: REQUEST_WAREHOUSES_AND_OPCOS });
